export enum MyRequestsComponentMode {
    MyRequests = 1,
    MyRequestsAnonymous = 2
}